var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [_c("pc-header"), _vm._m(0), _vm._m(1), _c("pc-footer")], 1)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-wrap" }, [
      _c("img", {
        attrs: { src: require("../../../assets/images/news/news-head-bg.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-wrap" }, [
      _c(
        "div",
        { staticClass: "title", staticStyle: { "text-align": "center" } },
        [_vm._v(" 关于降低商户银行卡刷卡手续费的公告 ")]
      ),
      _c(
        "div",
        { staticClass: "time", staticStyle: { "text-align": "center" } },
        [_vm._v(" 发布时间： 2021-08-10 ")]
      ),
      _c("div", { staticClass: "news_details_container" }, [
        _c("p", [_vm._v("尊敬的商户：")]),
        _c("p", { staticStyle: { "text-indent": "2em" } }, [
          _vm._v(
            "为贯彻落实国务院关于降低小微企业和个体工商户支付手续费工作部署和《中国人民银行 银保监会 发展改革委 市场监管总局关于降低小微企业和个体工商户支付手续费的通知》（银发〔2021〕169号），中国支付清算协会和中国银行业协会共同发布《关于降低小微企业和个体工商户支付手续费的倡议书》。我公司积极主动承担社会责任，进一步降低商户的经营成本，结合业务实际开展情况以及中国银联股份有限公司发布的《关于调整小微企业和个体工商户有关银联卡业务手续费的函》（银联函〔2021〕32号），计划自2021年9月30日起三年内，施行降低银行卡刷卡手续费的优惠政策。同时我公司将做好以下服务工作："
          )
        ]),
        _c("ol", { staticClass: "custom_num list-paddingleft-1" }, [
          _c("li", { staticClass: "list-num-1-1 list-num-paddingleft-1" }, [
            _c("p", [
              _vm._v("1、做好宣传和信息披露，确保商户对优惠政策充分知晓；")
            ])
          ]),
          _c("li", { staticClass: "list-num-1-2 list-num-paddingleft-1" }, [
            _c("p", [
              _vm._v(
                "2、做好各项准备工作，制定业务规则、技术实施方案和应急处置方案，确保9月30日前具备业务和系统支撑能力，将降费措施落实到位；"
              )
            ])
          ]),
          _c("li", { staticClass: "list-num-1-3 list-num-paddingleft-1" }, [
            _c("p", [
              _vm._v(
                "3、切实做好金融消费者权益保护工作，畅通投诉和争议处理的渠道，确保快速响应、及时处理。 "
              )
            ])
          ])
        ]),
        _c(
          "p",
          { staticStyle: { "text-align": "left", "text-indent": "2em" } },
          [
            _vm._v(
              "今后，海科融通作为支付机构的国家队成员，将继续坚守和践行“支付为民”的理念，积极履行社会责任，多措并举，切实推动银行卡刷卡手续费减免措施的落地，与广大商户一道共克时艰。"
            )
          ]
        ),
        _c("p", { staticStyle: { "text-align": "right" } }, [
          _vm._v("北京海科融通支付服务有限公司")
        ]),
        _c("p", { staticStyle: { "text-align": "right" } }, [
          _vm._v("2021年8月9日")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }